import { CORE_API_AKADEMIK } from "../../key/api"

// API GET METHOD
export async function getPresensi(data) {
    try {
        const response = await CORE_API_AKADEMIK.get('detail/presensi?nim=' + data.nim + '&semester=' + data.semester + '&kurikulum=' + data.kurikulum)
        return response
    }
    catch (err) {
        return false
    }
}